import { render, staticRenderFns } from "./UiProductContainer.vue?vue&type=template&id=bdf8d1f6&"
import script from "./UiProductContainer.vue?vue&type=script&lang=js&"
export * from "./UiProductContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports